@if (loading()) {
  <div class="slider">
    <div class="line"></div>
    <div class="sub-line inc"></div>
    <div class="sub-line dec"></div>
  </div>
}

<div id="gl-loader" class="loader-container">
  <div class="tiny-logo"></div>
  <div class="loader">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>

<router-outlet (activate)="onActivate()"></router-outlet>
